import { memo } from 'react';
interface AssistantUserBubbleProps {
  text: string;
}

function AssistantUserBubbleContent({ text }: AssistantUserBubbleProps) {
  return (
    <div className="flex flex-col items-end">
      <div className="max-w-[85%] rounded-2xl rounded-br-sm px-4 py-2.5 bg-zooprimary text-zoowhite">
        <p className="text-sm whitespace-pre-wrap break-words">{text}</p>
      </div>
    </div>
  );
}

export const AssistantUserBubble = memo(AssistantUserBubbleContent);
